<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="admin-panel">
    <!-- <app-banner-footer-pages [title]="title1"></app-banner-footer-pages> -->
    <!-- <app-banner-profile
      [image]="img1"
      [title]="title"
      [customClasses]="class1"
    ></app-banner-profile> -->
    <!-- <app-main-heading [title]="title"></app-main-heading> -->
    <div class="business-category-page">
      <div class="innerpageContent mb-5">
        <div class="top-categeryHead">
          <div class="categeryHead-text">
            <h1 [innerHTML]="title1"></h1>
          </div>
          <div class="btnGrpp">
            <button class="gredientOutLineBtn" (click)="toggleModelB()">
              <div class="btnContent">
                + New State
                <!-- <img src="./assets/images/edit-line.svg" alt="edit" /> -->
              </div>
            </button>
          </div>
        </div>

        <div class="admin-table">
          <table class="adminPanel-table">
            <tr>
              <th colspan="2">State name</th>
              <th>State GST Code</th>
              <th>added Date</th>
              <th>ACTIONS</th>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">andhra pradesh</td>
              <td>002</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">andhra pradesh</td>
              <td>002</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">andhra pradesh</td>
              <td>002</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">andhra pradesh</td>
              <td>002</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">andhra pradesh</td>
              <td>002</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="innerpageContent mb-5">
        <div class="top-categeryHead">
          <div class="categeryHead-text">
            <h1 [innerHTML]="title2"></h1>
          </div>
          <div class="btnGrpp">
            <button class="gredientOutLineBtn" (click)="toggleModel()">
              <div class="btnContent">
                + New Language
                <!-- <img src="./assets/images/edit-line.svg" alt="edit" /> -->
              </div>
            </button>
          </div>
        </div>

        <div class="admin-table">
          <table class="adminPanel-table">
            <tr>
              <th colspan="2">Language Name</th>
              <th>Language Icon</th>
              <th>Language Code</th>
              <th>added Date</th>
              <th>ACTIONS</th>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">English</td>
              <td class="business-thumbnail">
                <img src="../../../assets/images/add-file.svg" alt="" />
              </td>
              <td>en</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">English</td>
              <td class="business-thumbnail">
                <img src="../../../assets/images/add-file.svg" alt="" />
              </td>
              <td>en</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">English</td>
              <td class="business-thumbnail">
                <img src="../../../assets/images/add-file.svg" alt="" />
              </td>
              <td>en</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">English</td>
              <td class="business-thumbnail">
                <img src="../../../assets/images/add-file.svg" alt="" />
              </td>
              <td>en</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="serielNo">1</td>
              <td class="align-left">English</td>
              <td class="business-thumbnail">
                <img src="../../../assets/images/add-file.svg" alt="" />
              </td>
              <td>en</td>
              <td>24/10/2023</td>
              <td>
                <div class="actions">
                  <div class="action-edit">
                    <img src="../../../assets/images/edit-icon.svg" alt="" />
                  </div>
                  <div class="action-del">
                    <img src="../../../assets/images/trash-icon.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<c-modal
  id="productDetails"
  [visible]="showAddModelB"
  backdrop="static"
  class="appModel"
  alignment="center"
  size="lg"
>
  <div class="modelContentBox py-3 px-4">
    <div class="modelheader mb-3">
      <button
        (click)="toggleModelB()"
        cButtonClose
        class="modelClose productModelCloseBtn"
      >
        <img src="../../../assets/images/c-remove-btn.svg" alt="" />
      </button>
    </div>
    <div class="modelBody">
      <!-- <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title3"></h1>
        </div>
      </div> -->
      <app-main-heading [title]="title3"></app-main-heading>
      <div class="add-category-contents">
        <form>
          <div class="innerpageContent">
            <div class="row g-2 g-lg-4">
              <div class="col-lg-8 col-8">
                <div class="inputGroup">
                  <input
                    onkeydown="return /[a-z ]/i.test(event.key)"
                    type="text"
                    formControlName="Article-title"
                    class="inputBox"
                    id="documentName"
                    placeholder=""
                  />
                  <label for="documentName" class="inputLabel"
                    >State Name</label
                  >
                </div>
              </div>
              <div class="col-lg-4 col-4">
                <div class="inputGroup">
                  <input
                    onkeydown="return /[a-z ]/i.test(event.key)"
                    type="text"
                    formControlName="Article-title"
                    class="inputBox"
                    id="expiryDate"
                    placeholder=""
                  />
                  <label for="expiryDate" class="inputLabel"
                    >State GST Code</label
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <div class="btnbx mt-5">
              <button type="button" class="btnThemeOutline blue me-3">
                Cancel
              </button>
              <button class="btnTheme red" type="submit">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</c-modal>
<c-modal
  id="productDetails"
  [visible]="showAddModel"
  backdrop="static"
  class="appModel"
  alignment="center"
  size="lg"
>
  <div class="modelContentBox py-3 px-4">
    <div class="modelheader mb-3">
      <button
        (click)="toggleModel()"
        cButtonClose
        class="modelClose productModelCloseBtn"
      >
        <img src="../../../assets/images/c-remove-btn.svg" alt="" />
      </button>
    </div>
    <div class="modelBody">
      <!-- <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title4"></h1>
        </div>
      </div> -->
      <app-main-heading [title]="title4"></app-main-heading>

      <div class="add-category-contents">
        <form>
          <div class="innerpageContent">
            <div class="add-cat-thumb">
              <div class="row">
                <div class="col-lg-12">
                  <div class="inputGroup">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      type="text"
                      formControlName="Article-title"
                      class="inputBox"
                      id="businessCategory"
                      placeholder=""
                    />
                    <label for="businessCategory" class="inputLabel"
                      >Language Name</label
                    >
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="inputGroup">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      type="text"
                      formControlName="Article-title"
                      class="inputBox"
                      id="categoryDescription"
                      placeholder=""
                    />
                    <label for="categoryDescription" class="inputLabel"
                      >Language Code</label
                    >
                  </div>
                </div>
              </div>
              <div class="thumbnail-box">
                <div class="thumbnail-text">Upload Thumbnail</div>
                <div class="add-thumbnail" (click)="toggleModelc()">
                  <img src="../../../assets/images/add-file.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <div class="btnbx mt-5">
              <button type="button" class="btnThemeOutline blue me-3">
                Cancel
              </button>
              <button class="btnTheme red" type="submit">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</c-modal>
